import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { Helmet, HelmetProvider } from "react-helmet-async";
import ScrollSpy from "react-ui-scrollspy";
import GotoTop from "../common/GotoTop";
import ContactCTA from "../contact/contactCTA";
import CloudConsultationBanner from "./CloudConsultationBanner";
import CloudConsultationFaq from "./CloudConsultationFaq";
import CloudConsultationInfo from "./CloudConsultationInfo";
import CloudConsultationService from "./CloudConsultationService";

const CloudConsultationHome = () => {
  return (
    <div>
      <HelmetProvider>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            Flint Infotech - Strategic Cloud Consultation for Transformative
            Digital Solutions
          </title>
          <meta
            name="description"
            content="Flint Infotech provides expert Strategic Cloud Consultation services, offering tailored strategies for businesses to maximize efficiency and ROI. Schedule a consultation for innovative, scalable, and secure digital transformation in the cloud era."
          />
          <link rel="canonical" href="https://flintinfotech.com/" />

          <meta
            property="og:title"
            content="Flint Infotech - Strategic Cloud Consultation for Transformative Digital Solutions"
          />
          <meta
            property="og:description"
            content="Flint Infotech provides expert Strategic Cloud Consultation services, offering tailored strategies for businesses to maximize efficiency and ROI. Schedule a consultation for innovative, scalable, and secure digital transformation in the cloud era."
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://flintinfotech.com/" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="Flint Infotech - Strategic Cloud Consultation for Transformative Digital Solutions"
          />
          <meta
            name="twitter:description"
            content="Flint Infotech provides expert Strategic Cloud Consultation services, offering tailored strategies for businesses to maximize efficiency and ROI. Schedule a consultation for innovative, scalable, and secure digital transformation in the cloud era."
          />

          <meta name="robots" content="index, follow" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
      </HelmetProvider>

      <CloudConsultationBanner />
      <ScrollSpy>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <CloudConsultationInfo />
        </AnimationOnScroll>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <CloudConsultationService />
        </AnimationOnScroll>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <CloudConsultationFaq />
        </AnimationOnScroll>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <ContactCTA />
        </AnimationOnScroll>
      </ScrollSpy>
      <GotoTop />
    </div>
  );
};

export default CloudConsultationHome;
